import { useState } from "react";
import { FaCheck } from "react-icons/fa";
import {useSettings} from "../../context/SettingsContext";
import { t } from "context/translations";
import { assetUrl } from "utils/api";
const VariantSelector = ({
  variants,
  selectedVariant,
  setSelectedVariant,
  setSelectedImage,
}) => {
  const [open, setOpen] = useState(false);
  const { theme, language } = useSettings();
  const isDark = theme === "dark";
  const handleSelect = (variant) => {
    setSelectedVariant(variant);
    const firstImage = variant.images?.[0];
    setSelectedImage({
      variant: variant,
      type: "image",
      thumb: assetUrl(firstImage?.thumb || firstImage?.original || ""),
      original: assetUrl(firstImage?.original || firstImage?.thumb || ""),
      src: assetUrl(firstImage?.original || firstImage?.thumb || ""),
      imageIndex: 0,
    });
    setOpen(false);
    console.log("variant", variant);
  };

  return (
    <div className="mb-6">
      {/* Label */}
      <p className="text-sm font-medium text-gray-700 mb-2"> {t("selectVariant", language)}</p>

      {/* Trigger */}
      <div
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between 
        px-4 py-3 rounded-xl border border-gray-200 bg-white 
        shadow-sm cursor-pointer
        hover:border-[#FF4747] transition-all duration-200"
      >
        <span className={`text-sm md:text-base ${isDark?"text-white":"text-gray-800"} `}>
          {selectedVariant?.title || "Choose variant"}
        </span>

        <span className={`transition-transform ${open ? "rotate-180" : ""}`}>
          ▼
        </span>
      </div>

      {/* Dropdown */}
      {open && (
        <div className="mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden z-50">
          {variants.map((variant) => {
            const isSelected =
              selectedVariant?.variant_id === variant.variant_id;

            return (
              <div
                key={variant.variant_id}
                onClick={() => handleSelect(variant)}
                className={`flex items-center justify-between px-4 py-3 cursor-pointer
                transition-all duration-200
                ${
                  isSelected ? "bg-red-50 text-[#FF4747]" : "hover:bg-gray-50"
                }`}
              >
                <span className="text-sm md:text-base">{variant.title}</span>

                {isSelected && <FaCheck className="text-[#FF4747] text-xs" />}
              </div>
            );
          })}
        </div>
      )}

      {/* Helper */}
      <p className="text-xs text-gray-400 mt-1">
        {t("chooseYourPreferredVariant", language)}
      </p>
    </div>
  );
};

export default VariantSelector;
